import React from 'react';
import ShowIntervalProperties from "./ShowIntervalProperties";


const ShowInterval: React.FC<ShowIntervalProperties> = ({
                                                        from,
                                                        to,
                                                        horizontal = true,
                                                      }) => {

    return (
        <div>
            <>
                {horizontal && <div>{from} - {to}</div>}
                {!horizontal &&
                    <div>
                        <div><strong>De: </strong>{from}</div>
                        <div><strong>Hasta: </strong>{to}</div>
                    </div>
                }
            </>
        </div>
    )
}
export default ShowInterval;